"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRenderPages = exports.TablePaginationActions = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _ChevronLeftIcon = _interopRequireDefault(require("../../assets/Icons/ChevronLeftIcon"));
var _ChevronRightIcon = _interopRequireDefault(require("../../assets/Icons/ChevronRightIcon"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["count", "rowsPerPage", "renderPages", "page", "onPageChange"];
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var PagesWrapper = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: baseline;\n    white-space: nowrap;\n    margin-left: 24px;\n"])));
var IconsWrapper = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-shrink: 0;\n    margin-left: 16px;\n    margin-right: 12px;\n    width: 72px;\n    justify-content: space-between;\n"])));
var defaultRenderPages = function defaultRenderPages(_ref) {
  var page = _ref.page,
    totalPages = _ref.totalPages,
    pageInputProps = _ref.pageInputProps,
    onPageChange = _ref.onPageChange,
    pageLabel = _ref.pageLabel,
    ofLabel = _ref.ofLabel;
  var handlePageChange = function handlePageChange(_ref2) {
    var value = _ref2.target.value;
    var isValidNumber = /^[1-9][0-9]*$/.test(value);
    if (isValidNumber && +value <= totalPages) {
      onPageChange(null, +value - 1);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, null, pageLabel), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    height: "30px",
    width: "65px",
    margin: "0 4px"
  }, pageInputProps, {
    value: page + 1,
    onChange: handlePageChange,
    inputProps: _objectSpread(_objectSpread({}, pageInputProps === null || pageInputProps === void 0 ? void 0 : pageInputProps.inputProps), {}, {
      sx: _objectSpread({
        textAlign: 'center',
        minWidth: '40px'
      }, pageInputProps === null || pageInputProps === void 0 ? void 0 : pageInputProps.sx)
    })
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, null, ofLabel, " ", totalPages));
};
exports.defaultRenderPages = defaultRenderPages;
var TablePaginationActions = function TablePaginationActions(props) {
  var count = props.count,
    rowsPerPage = props.rowsPerPage,
    _props$renderPages = props.renderPages,
    renderPages = _props$renderPages === void 0 ? defaultRenderPages : _props$renderPages,
    page = props.page,
    onPageChange = props.onPageChange,
    rest = _objectWithoutProperties(props, _excluded);
  var totalPages = rowsPerPage === -1 ? 1 : Math.ceil(count / rowsPerPage);
  var handleBackButtonClick = function handleBackButtonClick(event) {
    onPageChange(event, page - 1);
  };
  var handleNextButtonClick = function handleNextButtonClick(event) {
    onPageChange(event, page + 1);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PagesWrapper, null, renderPages(_objectSpread({
    page: page,
    onPageChange: onPageChange,
    totalPages: totalPages
  }, rest))), /*#__PURE__*/_react.default.createElement(IconsWrapper, null, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleBackButtonClick,
    disabled: page === 0,
    icon: function icon(fill) {
      return /*#__PURE__*/_react.default.createElement(_ChevronLeftIcon.default, {
        height: 16,
        fill: fill
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleNextButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    icon: function icon(fill) {
      return /*#__PURE__*/_react.default.createElement(_ChevronRightIcon.default, {
        height: 16,
        fill: fill
      });
    }
  })));
};
exports.TablePaginationActions = TablePaginationActions;